import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SMTeamLogo from '../../../../../widgets/components/sm/views/SMTeamLogo';
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';

const Header = styled.div`
    display: flex;
    align-items: center;
    margin: 0 0 30px;

    h2 {
        margin: 0;

        font-size: 3em;
    }
`;

const Ul = styled.ul``;

const Li = styled.li`
    ${({ active }) => active && ``};
`;

const BtnWrapper = styled.div`
    display: flex;
    align-items: center;

    > * {
        margin-right: 10px;
    }
`;

function TeamHeader({ teamId = {}, team = {}, tournamentId = '', seasonId = '', tournaments = [] }) {
    return (
        <div>
            <Header>
                <SMTeamLogo width={100} style={{ marginRight: 10 }} teamId={teamId} />
                <h2>{team.name}</h2>
                <Ul>
                    {tournaments.filter(tournament => tournament.id !== tournamentId).map(tournament => (
                        <Li
                            key={tournament.id}
                            active={location.pathname.includes(
                                `/sm/browser/football/tournaments/${tournament.id}/${tournament.seasons &&
                                    tournament.seasons[tournament.seasons.length - 1] &&
                                    tournament.seasons[tournament.seasons.length - 1].id}/team/${teamId}`
                            )}
                        >
                            <Link
                                to={`/sm/browser/football/tournaments/${tournament.id}/${tournament.seasons &&
                                    tournament.seasons[tournament.seasons.length - 1] &&
                                    tournament.seasons[tournament.seasons.length - 1].id}/team/${teamId}`}
                            >
                                {tournament.name}
                            </Link>
                        </Li>
                    ))}
                </Ul>
            </Header>
            <BtnWrapper>
                <Link to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/home`}>
                    <RaisedButton
                        label="Home"
                        primary={location.pathname.includes(
                            `/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/home`
                        )}
                    />
                </Link>
                <Link to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/stats`}>
                    <RaisedButton
                        label="Stats"
                        primary={location.pathname.includes(
                            `/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/stats`
                        )}
                    />
                </Link>
                <Link to={`/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/squad`}>
                    <RaisedButton
                        label="Squad"
                        primary={location.pathname.includes(
                            `/sm/browser/football/tournaments/${tournamentId}/${seasonId}/team/${teamId}/squad`
                        )}
                    />
                </Link>
            </BtnWrapper>
        </div>
    );
}

TeamHeader.propTypes = {
    teamId: PropTypes.string.isRequired,
    team: PropTypes.object.isRequired,
    tournamentId: PropTypes.string.isRequired,
    seasonId: PropTypes.string.isRequired,
    tournaments: PropTypes.array.isRequired
};

export default TeamHeader;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TeamHeader.js
 **/